enum SharingType {
  COMPANY = "company",
  SITE = "site",
  AUDIT = "audit",
}

export default SharingType;
